export default __webpack_public_path__ + "static/27-2f3f2dd7394a95126b53ee559a82487a.png";